

















import Vue from "vue";
export default Vue.extend({
  props: ["tabs", "value"],
  setup() {
    return {};
  }
});
